import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Booking = () => {
  return (
    <div className="min-h-screen" style={{ background: 'var(--bg-primary)', paddingTop: '80px' }}>
      <div className="max-w-6xl mx-auto py-12" style={{ padding: '100px 7.6923%' }}>
        {/* Back Button */}
        <Link
          to="/contact"
          className="inline-flex items-center space-x-2 mb-8 dark-transition hover:opacity-80"
          style={{ color: 'var(--brand-primary)', textDecoration: 'none' }}
        >
          <ArrowLeft size={20} />
          <span className="body-medium">Back to Contact</span>
        </Link>

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="display-large mb-4" style={{ color: 'var(--text-primary)' }}>
            Schedule Your
            <span className="block" style={{ color: 'var(--brand-primary)' }}>
              Free Strategy Call
            </span>
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Book a 30-minute consultation to discuss your business goals and how we can help you achieve them.
          </p>
        </div>

        {/* Calendly Embed */}
        <div
          className="rounded-lg overflow-hidden"
          style={{
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid var(--border-subtle)',
            minHeight: '800px'
          }}
        >
          <iframe
            src="https://calendly.com/americanprimeforyou"
            width="100%"
            height="800px"
            frameBorder="0"
            title="Book a Free Strategy Call"
            style={{ background: 'transparent' }}
          />
        </div>

        {/* What to Expect */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div
            className="p-6 rounded-lg"
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              border: '1px solid var(--border-subtle)'
            }}
          >
            <div className="heading-2 mb-2" style={{ color: 'var(--brand-primary)' }}>
              30 Minutes
            </div>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              Focused consultation to understand your business needs
            </p>
          </div>
          <div
            className="p-6 rounded-lg"
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              border: '1px solid var(--border-subtle)'
            }}
          >
            <div className="heading-2 mb-2" style={{ color: 'var(--brand-primary)' }}>
              100% Free
            </div>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              No commitment required, just valuable insights
            </p>
          </div>
          <div
            className="p-6 rounded-lg"
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              border: '1px solid var(--border-subtle)'
            }}
          >
            <div className="heading-2 mb-2" style={{ color: 'var(--brand-primary)' }}>
              Custom Strategy
            </div>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              Personalized recommendations for your business
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;